"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotWithLabel = void 0;
var DotWithLabel_1 = require("./DotWithLabel");
Object.defineProperty(exports, "DotWithLabel", { enumerable: true, get: function () { return DotWithLabel_1.DotWithLabel; } });
